import { FiGift, FiDroplet, FiSun, FiLayout, FiStar, FiHeart, FiShoppingBag, FiHome } from 'react-icons/fi';

// Reliable Unsplash Image IDs for categories to prevent broken links
const productImages = {
  shower: 'https://images.unsplash.com/photo-1608248597279-f99d160bfbc8?auto=format&fit=crop&q=80&w=600',
  mist: 'https://images.unsplash.com/photo-1616683693504-3ea7e9ad6fec?auto=format&fit=crop&q=80&w=600',
  soap: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&q=80&w=600',
  cleaner: 'https://images.unsplash.com/photo-1585832669352-25de3702580c?auto=format&fit=crop&q=80&w=600',
  diffuser: 'https://images.unsplash.com/photo-1602928321679-560bb453f190?auto=format&fit=crop&q=80&w=600',
  perfume: 'https://images.unsplash.com/photo-1541643600914-78b084683601?auto=format&fit=crop&q=80&w=600',
  menPerfume: 'https://images.unsplash.com/photo-1523293182086-7651a899d37f?auto=format&fit=crop&q=80&w=600',
  cream: 'https://images.unsplash.com/photo-1608248597279-f99d160bfbc8?auto=format&fit=crop&q=80&w=600',
  feet: 'https://images.unsplash.com/photo-1519415387722-a1c3bbef716c?auto=format&fit=crop&q=80&w=600',
  lashes: 'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?auto=format&fit=crop&q=80&w=600',
  face: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&q=80&w=600'
};

export const shopCategories = [
  { id: 'all', name: 'All Products', icon: FiStar },
  { id: 'stanhome', name: 'Stanhome', icon: FiHome },
  { id: 'lashes', name: 'Lash Supplies', icon: FiShoppingBag },
  { id: 'aftercare', name: 'Aftercare', icon: FiDroplet },
];

export const shopProducts = [
  // ==========================================================================================
  // 🇲🇽 STANHOME COLLECTION (Full 24 Products)
  // ==========================================================================================
  {
    id: 'stan-1',
    category: 'stanhome',
    titleEn: 'Ritu’Elle Shower Gel Noël Enchanté 240 ML',
    titleEs: 'Ritu’Elle Gel de Ducha Noël Enchanté 240 ML',
    price: 150,
    descEn: 'Gel with sweet fruity Christmas aroma.',
    descEs: 'Gel con aroma navideño frutal dulce.',
    icon: FiDroplet,
    img: productImages.shower
  },
  {
    id: 'stan-2',
    category: 'stanhome',
    titleEn: 'Ritu’Elle Body Mist Noël Enchanté 240 ML',
    titleEs: 'Ritu’Elle Body Mist Noël Enchanté 240 ML',
    price: 180,
    descEn: 'Body mist with sweet fruity aroma for daily use.',
    descEs: 'Bruma corporal con aroma frutal dulce para uso diario.',
    icon: FiSun,
    img: productImages.mist
  },
  {
    id: 'stan-3',
    category: 'stanhome',
    titleEn: 'Ritu’Elle Hand Soap Noël Enchanté 240 ML',
    titleEs: 'Ritu’Elle Jabón para Manos Noël Enchanté 240 ML',
    price: 120,
    descEn: 'Liquid soap with sweet fruity Christmas aroma.',
    descEs: 'Jabón líquido con aroma navideño frutal dulce.',
    icon: FiDroplet,
    img: productImages.soap
  },
  {
    id: 'stan-4',
    category: 'stanhome',
    titleEn: 'Drop 30 ML Concentrated Odor Neutralizer',
    titleEs: 'Drop 30 ML Neutralizador de olores concentrado',
    price: 90,
    descEn: 'Eliminates strong odors instantly.',
    descEs: 'Elimina olores fuertes al instante.',
    icon: FiLayout,
    img: productImages.cleaner
  },
  {
    id: 'stan-5',
    category: 'stanhome',
    titleEn: 'Green Aromatic Diffuser 1 PC',
    titleEs: 'Difusor Aromático Verde 1 PZ',
    price: 250,
    descEn: 'Elegant diffuser to scent spaces.',
    descEs: 'Difusor elegante para ambientar espacios.',
    icon: FiSun,
    img: productImages.diffuser
  },
  {
    id: 'stan-6',
    category: 'stanhome',
    titleEn: 'Stan-Wick 250 ML | Wick Air Freshener',
    titleEs: 'Stan-Wick 250 ML | Desodorante en mecha para ambientes',
    price: 110,
    descEn: 'Wick air freshener for environments.',
    descEs: 'Desodorante en mecha para ambientes.',
    icon: FiSun,
    img: productImages.diffuser
  },
  {
    id: 'stan-7',
    category: 'stanhome',
    titleEn: 'Body Cream 950 ML | Moisturizing Body Cream',
    titleEs: 'Body Cream 950 ML | Crema hidratante corporal',
    price: 220,
    descEn: 'Family size moisturizing body cream.',
    descEs: 'Crema hidratante corporal familiar.',
    icon: FiDroplet,
    img: productImages.cream
  },
  {
    id: 'stan-8',
    category: 'stanhome',
    titleEn: 'Ritu’Elle Body Exfoliant Noël Enchanté 170 g',
    titleEs: 'Ritu’Elle Exfoliante Corporal Noël Enchanté 170 g',
    price: 160,
    descEn: 'Christmas scrub with sweet fruity aroma.',
    descEs: 'Exfoliante navideño con aroma frutal dulce.',
    icon: FiStar,
    img: productImages.shower
  },
  {
    id: 'stan-9',
    category: 'stanhome',
    titleEn: 'Fresca Pie Ministerios de Amor 930 ML',
    titleEs: 'Fresca Pie Ministerios de Amor 930 ML',
    price: 190,
    descEn: 'Horse Chestnut – Special Cause Edition.',
    descEs: 'Castaña de Indias – Edición Especial con Causa.',
    icon: FiHeart,
    img: productImages.feet
  },
  {
    id: 'stan-10',
    category: 'stanhome',
    titleEn: 'Kiotis Essence Pour Femme 60 ML',
    titleEs: 'Kiotis Essence Pour Femme 60 ML',
    price: 350,
    descEn: 'Perfume for women with notes of jasmine and orchid.',
    descEs: 'Perfume para mujer con notas de jazmín y orquídea.',
    icon: FiGift,
    img: productImages.perfume
  },
  {
    id: 'stan-11',
    category: 'stanhome',
    titleEn: 'Kiotis Estilo Platinum 100 ML',
    titleEs: 'Kiotis Estilo Platinum 100 ML',
    price: 350,
    descEn: 'Eau de Toilette for Men with Essential Oils.',
    descEs: 'Eau de Toilette para Hombre con Aceites Esenciales.',
    icon: FiGift,
    img: productImages.menPerfume
  },
  {
    id: 'stan-12',
    category: 'stanhome',
    titleEn: 'Degreaser 1L | Antibacterial Grease Remover',
    titleEs: 'Degreaser 1L | Lavatrastes quitagrasa antibacterial',
    price: 140,
    descEn: 'Antibacterial dishwashing grease remover.',
    descEs: 'Lavatrastes quitagrasa antibacterial.',
    icon: FiLayout,
    img: productImages.cleaner
  },
  {
    id: 'stan-13',
    category: 'stanhome',
    titleEn: 'Pre-Poop Spray 60 ML',
    titleEs: 'Pre-Poop Spray 60 ML',
    price: 85,
    descEn: 'Toilet odor neutralizer.',
    descEs: 'Neutralizador de olores para inodoro.',
    icon: FiDroplet,
    img: productImages.cleaner
  },
  {
    id: 'stan-14',
    category: 'stanhome',
    titleEn: 'Daily Bed Fresh 240 ML',
    titleEs: 'Daily Bed Fresh 240 ML',
    price: 130,
    descEn: 'Mite and bedbug repellent.',
    descEs: 'Repelente de ácaros y chinches.',
    icon: FiHome,
    img: productImages.cleaner
  },
  {
    id: 'stan-15',
    category: 'stanhome',
    titleEn: 'Fresca Pie® Ice 300 ML',
    titleEs: 'Fresca Pie® Ice 300 ML',
    price: 110,
    descEn: 'Lotion for Tired Feet and Legs.',
    descEs: 'Loción para Pies y Piernas Cansadas.',
    icon: FiHeart,
    img: productImages.feet
  },
  {
    id: 'stan-16',
    category: 'stanhome',
    titleEn: 'Pavan’Elle Specific Collagen Facial Serum 18 ML',
    titleEs: 'Pavan’Elle Specific Suero Facial Colágeno 18 ML',
    price: 290,
    descEn: 'Wrinkle filler serum with firming effect.',
    descEs: 'Suero rellenador de arrugas con efecto firmeza.',
    icon: FiStar,
    img: productImages.face
  },
  {
    id: 'stan-17',
    category: 'stanhome',
    titleEn: 'Bakuchiol Facial Serum 18 ML',
    titleEs: 'Suero Facial Bakuchiol 18 ML',
    price: 310,
    descEn: 'Renews your skin without irritation.',
    descEs: 'Renueva tu piel sin irritación.',
    icon: FiStar,
    img: productImages.face
  },
  {
    id: 'stan-18',
    category: 'stanhome',
    titleEn: 'StanPack Biphasic Makeup Remover 3 Pieces',
    titleEs: 'StanPack Desmaquillante Bifásico 3 Piezas',
    price: 450,
    descEn: 'Gentle and Effective Cleaning.',
    descEs: 'Limpieza Suave y Efectiva.',
    icon: FiGift,
    img: productImages.face
  },
  {
    id: 'stan-19',
    category: 'stanhome',
    titleEn: 'Fresca Pie® Lotion',
    titleEs: 'Fresca Pie® loción',
    price: 120,
    descEn: 'Refreshing relief for tired feet and legs.',
    descEs: 'Alivio refrescante para pies y piernas cansadas.',
    icon: FiHeart,
    img: productImages.feet
  },
  {
    id: 'stan-20',
    category: 'stanhome',
    titleEn: 'StanPack Total Firming 2 Pieces',
    titleEs: 'StanPack Reafirmante Total 2 Piezas',
    price: 500,
    descEn: 'Tones and Firms Your Body.',
    descEs: 'Tonifica y Da Firmeza a Tu Cuerpo.',
    icon: FiGift,
    img: productImages.cream
  },
  {
    id: 'stan-21',
    category: 'stanhome',
    titleEn: 'Drop 30 ML Pink Champagne',
    titleEs: 'Drop 30 ML Pink Champagne',
    price: 95,
    descEn: 'Pink Champagne odor neutralizer.',
    descEs: 'Neutralizador de olores Pink Champagne.',
    icon: FiDroplet,
    img: productImages.cleaner
  },
  {
    id: 'stan-22',
    category: 'stanhome',
    titleEn: 'Goddess Pack | 3 Fragrances for Women',
    titleEs: 'Pack Diosas | 3 Fragancias para mujer',
    price: 850,
    descEn: '3 Exclusive fragrances for women.',
    descEs: '3 Fragancias exclusivas para mujer.',
    icon: FiGift,
    img: productImages.perfume
  },
  {
    id: 'stan-23',
    category: 'stanhome',
    titleEn: 'Kiotis Raíces Ámbar 60 ML',
    titleEs: 'Kiotis Raíces Ámbar 60 ML',
    price: 380,
    descEn: 'Floral fruity perfume with Mexican essence.',
    descEs: 'Perfume floral frutal con esencia mexicana.',
    icon: FiStar,
    img: productImages.perfume
  },
  {
    id: 'stan-24',
    category: 'stanhome',
    titleEn: 'Pavan’Elle White Lightening Serum 18 ML',
    titleEs: 'Pavan’Elle White Suero Aclarante 18 ML',
    price: 280,
    descEn: 'Mother of pearl + Vitamin C for an even tone.',
    descEs: 'Concha nácar + Vitamina C para un tono uniforme.',
    icon: FiStar,
    img: productImages.face
  },

  // ==========================================================================================
  // 👁️ EXISTING LASH PRODUCTS
  // ==========================================================================================
  {
    id: 'lash-kit-pro',
    category: 'lashes',
    titleEn: 'Premium Lash Extension Starter Kit',
    titleEs: 'Kit de Inicio Premium de Extensiones',
    price: 2500,
    descEn: 'Complete professional kit: 10 trays, adhesive, primer, tweezers.',
    descEs: 'Kit profesional completo: 10 charolas, adhesivo, primer, pinzas.',
    icon: FiShoppingBag,
    img: productImages.lashes
  },
  {
    id: 'lash-adhesive',
    category: 'lashes',
    titleEn: 'Professional-Grade Adhesive (10ml)',
    titleEs: 'Adhesivo de Grado Profesional (10ml)',
    price: 500,
    descEn: 'Fast-drying, 3-4 week bond. Hypoallergenic formula.',
    descEs: 'Secado rápido, retención de 3-4 semanas. Fórmula hipoalergénica.',
    icon: FiDroplet,
    img: 'https://images.unsplash.com/photo-1629198728461-9f93922d99c3?auto=format&fit=crop&q=80&w=600'
  },
  {
    id: 'lash-shampoo',
    category: 'aftercare',
    titleEn: 'Lash Bath Cleanser',
    titleEs: 'Shampoo para Pestañas (Lash Bath)',
    price: 300,
    descEn: 'Daily foam cleanser. Oil-free formula gentle on lashes.',
    descEs: 'Limpiador en espuma diario. Fórmula sin aceite suave con las pestañas.',
    icon: FiDroplet,
    img: 'https://images.unsplash.com/photo-1556228720-1977936af935?auto=format&fit=crop&q=80&w=600'
  }
];